
import { defineComponent } from "vue";
import frLocale from "element-plus/lib/locale/lang/fr";
import enLocale from "element-plus/lib/locale/lang/en";
import deLocale from "element-plus/lib/locale/lang/de";
import nlLocale from "element-plus/lib/locale/lang/nl";

/* global Office */

const elementPlusLocales = {
  fr: frLocale,
  en: enLocale,
  de: deLocale,
  nl: nlLocale,
};

export default defineComponent({
  name: "App",
  setup() {
    const language = Office.context.displayLanguage.substring(0, 2).toLowerCase();
    const locale = elementPlusLocales[language as keyof typeof elementPlusLocales] ?? enLocale;
    return {
      locale: locale,
    };
  },
});
